module.exports = __webpack_public_path__ + "static/media/plane(12).a303c06a.PNG";